<template>
    <section>
        <div class="c">

            <Thanks v-if="success"></Thanks>

            <div v-else class="c fadeInUp flex -wrap -justify-center">

                <div class="centered__item text-center">
                    <h3 v-if="loggedin">{{ $t('products.order_place') }}</h3>
                    <h3 v-else>{{ $t('products.request_quote') }}</h3>
                    <div>
                        <span class="primary-lighter">
                            {{ $tc('products.products', cartQty.amount) }}
                        </span>
                        <template v-if="$store.getters['Auth/isAuthenticated']">
                            - {{ cartQty.price | priceformat }}
                        </template>
                    </div>
                    <br />
                    <router-link :to="{ name: 'products', params: { mode: 'cart' }}" tag="button">{{ $t('products.cart') }}</router-link>
                </div>

                <div class="-flex-stretch"></div>

                <CheckoutForm @order="order" :ccs="ccs" :loading="loading"></CheckoutForm>
            </div>

        </div>
    </section>
</template>

<script>
import { api } from '@bit/duncank.work.api';
import CheckoutForm from '@/views/checkout/Form.vue';

export default {
    name: 'Checkout',
    components: {
        CheckoutForm,
        Thanks: () => import('@/views/checkout/Thanks.vue'),
    },
    data() {
        return {
            loading: false,
            success: false,
            ccs: {},
        };
    },
    computed: {
        cartQty() {
            return this.$store.getters['Products/cartQty'];
        },

        loggedin() {
            return this.$store.getters['Auth/isAuthenticated'];
        },
    },
    methods: {
        order() {
            this.loading = true;
            this.$store.dispatch('Products/order')
                .then(() => {
                    this.success = true;
                }).catch((err) => {
                    console.log(err);
                }).finally(() => {
                    this.loading = false;
                });
        },

        getCCAmount() {
            const cart = this.$store.getters['Products/cart'];
            const cartMap = cart.map(it => ({ amount: it.amount, product: it.product.id }));
            api.get({
                name: 'CC',
                endpoint: 'cc/',
                data: { data: JSON.stringify(cartMap) },
            }).then((r) => {
                this.ccs = r.data.results;
            }).catch((err) => {
                console.log(err);
            });
        },
    },
    watch: {
        cartQty: {
            handler: 'getCCAmount',
            immediate: true,
        },
    },
};
</script>
<style>
    .checkoutform {
        width: 100%;
    }
    .form--column {
        flex: 0 0 36rem;
        margin-bottom: 4rem;
    }
        .form--column + .form--column {
            margin-left: var(--padding-xxl);
        }
    @media (max-width: 47em){
        .form--column + .form--column { margin-left: 0; }
    }
</style>
